import type { FarmState } from '../domain/model';

export type AppMode = 'preview' | 'production';
export type FarmRole = 'propietario' | 'administrador' | 'operador' | 'consulta';
export interface AppUser { id: string; email?: string }
export interface FarmMembership { id: string; nombre: string; role: FarmRole }
export interface RemoteSnapshot { state: FarmState; revision: string }
export interface StorageLike {
  getItem(key: string): string | null;
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}
export interface FarmBackend {
  readonly writable: boolean;
  getUser(): Promise<AppUser | null>;
  getCachedUser(): Promise<AppUser | null>;
  signIn(username: string, password: string): Promise<AppUser>;
  signOut(): Promise<void>;
  onAuthChange(callback: (user: AppUser | null) => void): () => void;
  getMembership(userId: string): Promise<FarmMembership | null>;
  getSnapshot(farmId: string): Promise<RemoteSnapshot | null>;
  createFarm(userId: string, name: string): Promise<FarmMembership>;
  writeSnapshot(farmId: string, userId: string, state: FarmState, expectedRevision: string | null): Promise<RemoteSnapshot>;
}
export class SyncConflictError extends Error {
  constructor() { super('La finca cambió en otro dispositivo. Conservamos tu copia local; revisa el conflicto antes de sincronizar.'); this.name = 'SyncConflictError'; }
}
export const roleCanEdit = (role: FarmRole | null): boolean => role === 'propietario' || role === 'administrador' || role === 'operador';

export function resolveAppMode(configuredMode?: string, hostname = globalThis.location?.hostname || ''): AppMode {
  const local = !hostname || hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1' || hostname === '[::1]' || /^192\.168\./.test(hostname) || /^10\./.test(hostname) || /^172\.(1[6-9]|2\d|3[01])\./.test(hostname);
  return configuredMode === 'production' && !local ? 'production' : 'preview';
}
